
import { SFConstants } from "../../../constants/SFConstants";
import { ErrorCodes } from "../../../constants/shared/ErrorCodes";
import { Poker2FeatureDialog } from "../../../view/dialogs/teaser/Poker2FeatureDialog";
import { Poker2FeatureDialogProperties } from "../../../view/dialogs/teaser/Poker2FeatureDialogProperties";
import { Poker2Command } from "../Poker2Command";

export class FSTCommand extends Poker2Command {
    protected get cmdId(): string {
        return "fst";
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == 0) {
            var paramObj: any = JSON.parse(params[1]);
            var featureArray: any[] = paramObj.FID;
            for (var i: number = 0; i < featureArray.length; i++)
                this.layoutManager.showDialog("Poker2FeatureDialog", new Poker2FeatureDialogProperties(featureArray[i]));
        }
        return super.executeCommand(error, params);
    }

    /**
    * TRANSPILER GENERATED FUNCTION: If a overriding getter is defined, the setter must be defined as well. WARNING: the defining class was not found, so the parentclass was assumed. Please check if this call is correct.
    **/
    protected set cmdId(value/*:String*/)/*:void*/ {
        Object.getOwnPropertyDescriptor(Poker2Command.prototype, "cmdId").set.call(this, value);
    }
}
